var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},_vm._l((_vm.lectureList),function(list,index){return _c('div',{key:index,staticClass:"list",on:{"click":function($event){return _vm.openPdf(list)}}},[_c('h2',[_vm._v(_vm._s(list.name))]),_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/oneToOne/pdf2.png","alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }